import {
    FETCH_DRIVER_PARTNERS_REQUEST,
    FETCH_DRIVER_PARTNERS_SUCCESS,
    FETCH_DRIVER_PARTNERS_FAILURE,

    UPDATE_DRIVER_PARTNER_STATUS_REQUEST,
    UPDATE_DRIVER_PARTNER_STATUS_SUCCESS,
    UPDATE_DRIVER_PARTNER_STATUS_FAILURE,
} from "./types";

import {
    fetchAllDriverPartners,
    updateDriverPartnerStatus,
} from "../../services/driverPartnerService";



export const fetchDriverPartnersRequest = () => ({
    type: FETCH_DRIVER_PARTNERS_REQUEST,
});

export const fetchDriverPartnersSuccess = (
    driverPartners
) => ({
    type: FETCH_DRIVER_PARTNERS_SUCCESS,
    payload: driverPartners,
});

export const fetchDriverPartnersFailure = (
    error
) => ({
    type: FETCH_DRIVER_PARTNERS_FAILURE,
    payload: error,
});


export const updateDriverPartnerStatusRequest =
    () => ({
        type: UPDATE_DRIVER_PARTNER_STATUS_REQUEST,
    });

export const updateDriverPartnerStatusSuccess = (
    driverPartner
) => ({
    type: UPDATE_DRIVER_PARTNER_STATUS_SUCCESS,
    payload: driverPartner,
});

export const updateDriverPartnerStatusFailure = (
    error
) => ({
    type: UPDATE_DRIVER_PARTNER_STATUS_FAILURE,
    payload: error,
});


export const fetchDriverPartnersAction =
    (
        page = 1,
        size = 20,
        filterField = null,
        filterValue = null
    ) =>
    async (dispatch) => {
        dispatch(fetchDriverPartnersRequest());

        try {
            const response =
                await fetchAllDriverPartners(
                    page,
                    size,
                    filterField,
                    filterValue
                );

            if (!response.success) {
                dispatch(
                    fetchDriverPartnersFailure(
                        response.error
                    )
                );

                return response;
            }

            dispatch(
                fetchDriverPartnersSuccess(
                    response.data
                )
            );

            return response;
        } catch (error) {
            dispatch(
                fetchDriverPartnersFailure(
                    error.message
                )
            );

            return {
                success: false,
                error: error.message,
            };
        }
    };

export const updateDriverPartnerStatusAction =
    (
        driverPartnerId,
        status,
        statusReason = ""
    ) =>
    async (dispatch) => {
        dispatch(
            updateDriverPartnerStatusRequest()
        );

        try {
            const response =
                await updateDriverPartnerStatus(
                    driverPartnerId,
                    status,
                    statusReason
                );

            if (!response.success) {
                dispatch(
                    updateDriverPartnerStatusFailure(
                        response.error
                    )
                );

                return {
                    success: false,
                    error: response.error,
                };
            }

            dispatch(
                updateDriverPartnerStatusSuccess(
                    response.data
                )
            );

            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            const errMsg =
                error.message ||
                "Failed to update Driver Partner status";

            dispatch(
                updateDriverPartnerStatusFailure(
                    errMsg
                )
            );

            return {
                success: false,
                error: errMsg,
            };
        }
    };